import { Check } from '@tunasong/icons'
import type { FC, HTMLAttributes, MouseEvent } from 'react'
import { Button } from '@tunasong/ui-lib'
import styles from './vote-button.module.css'

export interface VoteButtonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  status: boolean | undefined
  disabled?: boolean
  onChange?(ev: MouseEvent, val: boolean): void
}

export const VoteButton: FC<VoteButtonProps> = props => {
  const { status, disabled, onChange, ...restProps } = props
  /** Only a pick is marked; an unpicked option already says so with its Vote button. `aria-pressed` carries it. */
  const startIcon =
    disabled && !status ? null : (
      <div className={status ? styles.iconSuccess : styles.iconHidden} aria-hidden>
        <Check />
      </div>
    )
  const handleClick = (ev: MouseEvent<HTMLButtonElement>) => {
    const newStatus = !status
    if (onChange) {
      onChange(ev, newStatus)
    }
  }

  return (
    <div className={styles.container} {...restProps}>
      {startIcon}
      {!disabled ? (
        <Button
          onClick={handleClick}
          disabled={disabled}
          // The enclosing <label> names this button after the option, so the picked state must be programmatic.
          aria-pressed={status === true}
        >
          <div className={status === true ? styles.unvoteText : undefined}>
            {status === false ? 'Vote' : null}
            {status === true ? 'Unvote' : null}
          </div>
        </Button>
      ) : null}
    </div>
  )
}

export default VoteButton
